import { Link, useNavigate } from "react-router-dom";
import { LogOut, KeyRound, ShieldCheck, Users, Building2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { tr } from "@/lib/i18n";
export const UserMenu = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  if (!user) return null;
  const initials = (user.name || user.email).split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="user-menu-trigger" className="w-9 h-9 shrink-0 rounded-full bg-slate-900 text-white text-xs font-semibold grid place-items-center hover:ring-2 hover:ring-[#0F52BA]/40 transition-shadow">
        {initials}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 z-[1000]">
        <DropdownMenuLabel className="font-normal">
          <div className="font-semibold text-slate-900 truncate" data-testid="user-menu-name">{user.name}</div>
          <div className="text-xs text-slate-500 truncate">{user.email}</div>
          <div className="mt-1.5 flex flex-wrap gap-1.5 text-[11px]">
            {user.role === "admin" && <span className="px-2 py-0.5 rounded-full bg-blue-50 text-[#0F52BA]">{tr("Super-admin")}</span>}
            <span className="px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 inline-flex items-center gap-1" data-testid="user-menu-group">
              <Users className="w-3 h-3" />{user.group_name || tr("Nessuna azienda")}
            </span>
            {user.group_role === "admin" && <span className="px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700">{tr("Admin azienda")}</span>}
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.group_id && <DropdownMenuItem asChild><Link to="/azienda" data-testid="user-menu-company"><Building2 className="w-4 h-4 mr-2" />{tr("La mia azienda")}</Link></DropdownMenuItem>}
        <DropdownMenuItem asChild><Link to="/account" data-testid="user-menu-account"><KeyRound className="w-4 h-4 mr-2" />{tr("Account e API key")}</Link></DropdownMenuItem>
        {user.role === "admin" && <DropdownMenuItem asChild><Link to="/admin" data-testid="user-menu-admin"><ShieldCheck className="w-4 h-4 mr-2" />{tr("Amministrazione")}</Link></DropdownMenuItem>}
        <DropdownMenuSeparator />
        <DropdownMenuItem data-testid="user-menu-logout" onClick={async () => { await logout(); nav("/accesso"); }}>
          <LogOut className="w-4 h-4 mr-2" />{tr("Esci")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
